import { END_URL } from "../../constants/endUrl";
import { httpPost } from "../httpMethods";

export const WatchoComplaintService = () => {
	const WatchoComplaintList = async (payload) => {
		try {
			const response = await httpPost(`${END_URL.WatchoComplain}`, payload);
			return response;
		} catch (error) {
			throw error;
		}
	};
	return {
		WatchoComplaintList,
	};
};
